<form *ngIf="groupForm" [formGroup]="groupForm" class="category-content">
    <div *ngFor="let criteria of group.commitmentCriterias" class="commitment-container">
        <span class="commitment-title">
          <mat-icon *ngIf="criteria.template.categoryLevel > 1" class="sublevel-icon">
            subdirectory_arrow_right
          </mat-icon>
          {{ criteria.template.title }}
        </span>
      <div class="commitment-container">
        <div class="tv-rect-input-small-no-label width-180px" [ngClass]="{ 'disabled-form-field': !criteria.template.editable || isPastYearContract }">
          <mat-form-field>
            <input
              matInput
              realThousandsSeparator
              [value]="criteria.value"
              [readonly]="!criteria.template.editable || isPastYearContract"
              (focusout)="onInputBaseChange(criteria, $event, criteria.template.editable)"
            />
            <span
              *ngIf="group.category === 'baseCategory'"
              matSuffix
              class="commitment-suffix"
            >%</span>
            <span
              *ngIf="!(group.category === 'baseCategory')"
              matPrefix
              class="commitment-prefix invisible"
            >%</span>
          </mat-form-field>
        </div>
        <mat-icon *ngIf="criteria.template.doubleValue" class="sublevel-icon">arrow_forward</mat-icon>
        <div *ngIf="criteria.template.doubleValue" class="tv-rect-input-small-no-label width-180px disabled-form-field">
          <mat-form-field>
            <input
              matInput
              realThousandsSeparator
              [formControlName]="groupPrefix + criteria.id"
              [value]="criteria.value2"
              (focusout)="onInputChange()"
              [readonly]="true"
            />
            <span matSuffix class="commitment-suffix">%</span>
          </mat-form-field>
        </div>
      </div>
    </div>
</form>
